// LanguageSwitcher.tsx — يبدّل لغة الواجهة (ar/en/pt) ويضبط اتجاه الصفحة (RTL للعربيّة).
import { useTranslation } from 'react-i18next';
import { Languages } from 'lucide-react';
import { Button } from '../components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '../components/ui/dropdown-menu';
import { cn } from '../lib/utils';

const LANGS: { code: string; label: string }[] = [
	{ code: 'ar', label: 'العربية' },
	{ code: 'en', label: 'English' },
	{ code: 'pt', label: 'Português' },
];

export function LanguageSwitcher() {
	const { i18n } = useTranslation();

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button variant="ghost" size="icon" aria-label="language">
					<Languages className="size-5" />
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent align="end" className="w-40">
				{LANGS.map((lang) => (
					<DropdownMenuItem key={lang.code} onClick={() => void i18n.changeLanguage(lang.code)} className={cn(i18n.language === lang.code && 'font-bold')}>
						{lang.label}
					</DropdownMenuItem>
				))}
			</DropdownMenuContent>
		</DropdownMenu>
	);
}
